// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

//         this.initTouchDrag();
//       }

//       initTouchDrag() {
//         const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
//         if (!slider) return;

//         // ── Force the slider to be natively scrollable ───────────────────
//         slider.style.overflowX         = 'auto';
//         slider.style.overflowY         = 'hidden';
//         slider.style.scrollSnapType    = 'x mandatory';
//         slider.style.webkitOverflowScrolling = 'touch';
//         slider.style.touchAction       = 'pan-x';
//         slider.style.cursor            = 'grab';
//         slider.style.scrollbarWidth    = 'none'; // Firefox
//         slider.style.msOverflowStyle   = 'none'; // IE/Edge

//         // Hide webkit scrollbar via a injected <style> tag (can't do via inline style)
//         if (!document.getElementById('mg-scrollbar-hide')) {
//           const st = document.createElement('style');
//           st.id = 'mg-scrollbar-hide';
//           st.textContent = `
//             [id^="Slider-Gallery"]::-webkit-scrollbar { display: none; }
//             [id^="Slider-Gallery"] .slider__slide {
//               scroll-snap-align: start;
//               flex-shrink: 0;
//             }
//           `;
//           document.head.appendChild(st);
//         }

// // ── Sync thumbnail + active state after native scroll settles ────
// let scrollTimer = null;
// slider.addEventListener('scroll', () => {
//   clearTimeout(scrollTimer);
//   scrollTimer = setTimeout(() => {
//     // Use the container's width and scroll position for more accuracy
//     const scrollLeft = slider.scrollLeft;
//     const slideWidth = slider.firstElementChild.offsetWidth; 
//     if (!slideWidth) return;

//     // Calculate the index based on the current scroll position
//     const index = Math.round(scrollLeft / slideWidth);
//     const slides = slider.querySelectorAll('[data-media-id]');
//     const targetSlide = slides[index];

//     if (targetSlide && !targetSlide.classList.contains('is-active')) {
//       // Only call setActiveMedia if the slide has actually changed
//       this.setActiveMedia(targetSlide.dataset.mediaId);
//     }
//   }, 100); // Reduced timeout for better responsiveness
// }, { passive: true });

//         // ── Mouse drag for desktop ───────────────────────────────────────
//         let isMouseDragging = false;
//         let startX = 0;
//         let startScrollLeft = 0;

//         slider.addEventListener('mousedown', (e) => {
//           isMouseDragging = true;
//           startX = e.clientX;
//           startScrollLeft = slider.scrollLeft;
//           slider.style.cursor = 'grabbing';
//           slider.style.scrollSnapType = 'none'; // disable snap while dragging
//           e.preventDefault();
//         });

//         slider.addEventListener('mousemove', (e) => {
//           if (!isMouseDragging) return;
//           slider.scrollLeft = startScrollLeft + (startX - e.clientX);
//         });

//         const onMouseUp = () => {
//           if (!isMouseDragging) return;
//           isMouseDragging = false;
//           slider.style.cursor = 'grab';
//           slider.style.scrollSnapType = 'x mandatory'; // re-enable snap on release
//           this.snapToSlide(slider);
//         };

//         slider.addEventListener('mouseup', onMouseUp);
//         slider.addEventListener('mouseleave', onMouseUp);
//       }

//       snapToSlide(slider) {
//         const slideWidth = slider.querySelector('.slider__slide')?.offsetWidth || slider.offsetWidth;
//         if (!slideWidth) return;
//         const targetIndex = Math.round(slider.scrollLeft / slideWidth);
//         slider.scrollTo({ left: targetIndex * slideWidth, behavior: 'smooth' });

//         setTimeout(() => {
//           const slides = slider.querySelectorAll('[data-media-id]');
//           const targetSlide = slides[targetIndex];
//           if (targetSlide) this.setActiveMedia(targetSlide.dataset.mediaId);
//         }, 300);
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) return;

//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia.classList.add('is-active');

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;

//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         if (!activeThumbnail) return;

//         this.setActiveThumbnail(activeThumbnail);

//         if (activeThumbnail.dataset.mediaPosition) {
//           this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//         }
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }


// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.initTouchDrag();
      }

      initTouchDrag() {
        const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        if (!slider) return;

        // Force scrollable
        slider.style.overflowX              = 'auto';
        slider.style.overflowY              = 'hidden';
        slider.style.scrollSnapType         = 'x mandatory';
        slider.style.webkitOverflowScrolling = 'touch';
        slider.style.touchAction            = 'pan-x';
        slider.style.cursor                 = 'grab';
        slider.style.scrollbarWidth         = 'none';
        slider.style.msOverflowStyle        = 'none';

        if (!document.getElementById('mg-scrollbar-hide')) {
          const st = document.createElement('style');
          st.id = 'mg-scrollbar-hide';
          st.textContent = `
            [id^="Slider-Gallery"]::-webkit-scrollbar { display: none; }
            [id^="Slider-Gallery"] .slider__slide {
              scroll-snap-align: start;
              flex-shrink: 0;
            }
          `;
          document.head.appendChild(st);
        }

        // ── Scroll-end sync (touch/native swipe) ────────────────────────
        // Use a flag to prevent setActiveMedia from re-triggering scroll
        this._suppressScrollSync = false;
        let scrollTimer = null;

        slider.addEventListener('scroll', () => {
          if (this._suppressScrollSync) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            this.syncActiveFromScroll(slider);
          }, 150);
        }, { passive: true });

        // ── Mouse drag (desktop) ─────────────────────────────────────────
        let isMouseDragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        slider.addEventListener('mousedown', (e) => {
          isMouseDragging = true;
          startX = e.clientX;
          startScrollLeft = slider.scrollLeft;
          slider.style.cursor = 'grabbing';
          slider.style.scrollSnapType = 'none'; // disable snap while dragging
          e.preventDefault();
        });

        slider.addEventListener('mousemove', (e) => {
          if (!isMouseDragging) return;
          slider.scrollLeft = startScrollLeft + (startX - e.clientX);
        });

        const onMouseUp = () => {
          if (!isMouseDragging) return;
          isMouseDragging = false;
          slider.style.cursor = 'grab';
          slider.style.scrollSnapType = 'x mandatory';
          this.snapToSlide(slider);
        };

        slider.addEventListener('mouseup', onMouseUp);
        slider.addEventListener('mouseleave', onMouseUp);
      }

      // Find the slide whose left edge is closest to the slider's left edge
      getNearestSlide(slider) {
        const slides = Array.from(slider.querySelectorAll('[data-media-id]'));
        if (!slides.length) return null;
        const containerLeft = slider.getBoundingClientRect().left;
        return slides.reduce((closest, slide) => {
          const dist = Math.abs(slide.getBoundingClientRect().left - containerLeft);
          const closestDist = Math.abs(closest.getBoundingClientRect().left - containerLeft);
          return dist < closestDist ? slide : closest;
        });
      }

      // Called after native touch scroll settles — only syncs thumbnail/active state,
      // does NOT call scrollTo on the slider (native snap already handled it)
      syncActiveFromScroll(slider) {
        const nearest = this.getNearestSlide(slider);
        if (!nearest) return;
        const mediaId = nearest.dataset.mediaId;

        // Mark active class without triggering scroll
        slider.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
        nearest.classList.add('is-active');

        // Sync thumbnail strip only
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail?.dataset.mediaPosition) {
            this.announceLiveRegion(nearest, activeThumbnail.dataset.mediaPosition);
          }
        }

        this.playActiveMedia(nearest);
      }

      // Called after mouse drag ends — scrolls to nearest then syncs
      snapToSlide(slider) {
        const nearest = this.getNearestSlide(slider);
        if (!nearest) return;

        // Suppress scroll listener while we programmatically scroll
        this._suppressScrollSync = true;
        slider.scrollTo({ left: nearest.offsetLeft, behavior: 'smooth' });

        setTimeout(() => {
          this._suppressScrollSync = false;
          this.syncActiveFromScroll(slider);
        }, 400);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      // Called by: thumbnail click, prev/next buttons, variant change
      // NOT called by drag — drag uses syncActiveFromScroll instead
      setActiveMedia(mediaId) {
        const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();

        window.setTimeout(() => {
          // Scroll the slider to this slide (suppressed during drag snap)
          if (slider && !this._suppressScrollSync) {
            this._suppressScrollSync = true;
            slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            setTimeout(() => { this._suppressScrollSync = false; }, 400);
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail.dataset.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => { this.elements.liveRegion.setAttribute('aria-hidden', true); }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
